<template>
  <div>
    <LineChart :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale } from "chart.js";
import { Line as LineChart } from "vue-chartjs";

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale);

export default {
  name: "NetworkChart",
  components: { LineChart },
  props: { inData: Array, outData: Array, labels: Array },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          { label: "Inbound Traffic", data: this.inData, borderColor: "#3b82f6", backgroundColor: "rgba(59,130,246,0.2)", tension: 0.4, fill: true },
          { label: "Outbound Traffic", data: this.outData, borderColor: "#10b981", backgroundColor: "rgba(16,185,129,0.2)", tension: 0.4, fill: true },
        ]
      };
    },
    chartOptions() {
      return { responsive: true, maintainAspectRatio: false, plugins: { legend: { labels: { color: "#d1d5db" } } }, scales: { x: { ticks: { color: "#9ca3af" }, grid: { color: "rgba(75, 85, 99, 0.2)" } }, y: { ticks: { color: "#9ca3af" }, grid: { color: "rgba(75, 85, 99, 0.2)" } } } };
    }
  }
};
</script>
